import { getLocalStorageWithExpiry, setLocalStorageWithExpiry } from "../common";
import { BaseStore } from "./base-store";

export class UserPreferencesStore extends BaseStore {

    defaultPreferences = {
        unit: "%",
    }

    getPreferences() {
        if (this.userPrefetences) return this.userPrefetences;

        let pref = getLocalStorageWithExpiry("userPreferences");
        if (pref) {
            this.userPrefetences = Object.assign({}, this.defaultPreferences, pref);
            return this.userPrefetences;
        }

        this.userPrefetences = Object.assign({}, this.defaultPreferences);

        return this.userPrefetences;
    }

    getPreference(key: string) {
        let pref = this.getPreferences();
        return pref[key];
    }

    setPreferences(preferences: any) {
        this.userPrefetences = preferences;
        setLocalStorageWithExpiry("userPreferences", preferences, 1000 * 60 * 60 * 24 * 7);
    }

    setPreference(key: string, value: any) {
        let pref = this.getPreferences();
        pref[key] = value;
        this.setPreferences(pref);
    }

}